import { render, staticRenderFns } from "./AsideLeaderBoardSection.vue?vue&type=template&id=8dbc07e6&"
import script from "./AsideLeaderBoardSection.vue?vue&type=script&lang=js&"
export * from "./AsideLeaderBoardSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports